import { ApolloLink } from '@apollo/client';
import { getToken } from './token';
import { IncomingHttpHeaders } from 'node:http';

export const authLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers }: { headers: IncomingHttpHeaders }) => ({
    headers: {
      ...headers,
      Authorization: getToken(),
    },
  }));
  return forward(operation);
});
